export default __webpack_public_path__ + "a9f30278bc821456eace1c129d1fea1e.gif";